import React from 'react'
import styled from 'styled-components'
import SEO from '../components/SEO';
import Layout from '../components/layout'
import URLSearchParams from '@ungap/url-search-params';

const Table = styled.table`
  line-height: 1rem;
`;

const Td = styled.td`
  width: 33%;
`;

const printDateKey = (identifier) => {
  const [gengo, year, month] = identifier.split('_');
  return `${gengo === 'H' ? '平成' : '令和'}${year}年${month}月`;
};

/* global fetch */
class CollocationPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { words: [] };
  }

  componentDidMount() {
    const params = new URLSearchParams(this.props.location.search);
    fetch(`/api/collocations/index.js?identifier=${params.get('identifier')}&word=${params.get('word')}`)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        this.setState({words: data})
      });
  }
  
  render() {
    const params = new URLSearchParams(this.props.location.search);
    if(!params.get('identifier')) { return null; }
    return (
      <Layout>
        <SEO title={`${params.get('word')}とよく使われた言葉`}/>
        <h2>{printDateKey(params.get('identifier'))}の議会で「{params.get('word')}」とよく使われた言葉</h2>
        <p>同一文内でよく使われた単語上位20件を表示しています。 </p>
        <div>
          <Table>
            {this.state.words.map((word, i) => {
              return <tr key={i}><Td>{word}</Td></tr>;
            })}
          </Table>
        </div>
      </Layout>
    );
  }
}

export default CollocationPage;